// extracted by mini-css-extract-plugin
export default {"box":"CookingHistoryList_box__t2Gfa","loader":"CookingHistoryList_loader__-8Jx1"};